/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line, G } from 'react-native-svg';

import { IconProps } from '../lib';

function DropHalf(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={128}
        y1={224}
        x2={128}
        y2={16}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={127.99999}
        y1={63.99999}
        x2={208}
        y2={144}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={127.99999}
        y1={111.99999}
        x2={198.26945}
        y2={182.26945}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <G>
        <Line
          x1={127.99999}
          y1={159.99999}
          x2={176.00281}
          y2={208.00281}
          fill="none"
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={16}
        />
        <Line
          x1={127.99999}
          y1={159.99999}
          x2={176.00281}
          y2={208.00281}
          fill="#231f20"
        />
      </G>
    </Svg>
  );
}

export default DropHalf;
